module.exports = __webpack_public_path__ + "img/82.1.c2a2e599.jpg";